import strings from './strings';

export enum AddressVerificationStatuses {
  VERIFIED = 'verified',
  NOT_VERIFIED = 'not_verified',
  NO_RESULTS = 'no_results',
}

export const StatusColorMapping = {
  [AddressVerificationStatuses.VERIFIED]: 'success',
  [AddressVerificationStatuses.NOT_VERIFIED]: 'warning',
  [AddressVerificationStatuses.NO_RESULTS]: 'critical',
};

export const LabelColorMapping = {
  [AddressVerificationStatuses.VERIFIED]: strings.labels.verified,
  [AddressVerificationStatuses.NOT_VERIFIED]: strings.labels.notVerified,
  [AddressVerificationStatuses.NO_RESULTS]: strings.labels.noResults,
};
